import React from 'react';
import classnames from 'classnames';

import './ProgressBar.scss';

type UIProgressBarProps = WithChildren<{
  className?: string;
  color?: 'good' | 'neutral' | 'bad' | 'target' | 'novalues';
  size?: 'small' | 'medium';
  value: number;
}>;

export default function UIProgressBar({
  children = null,
  className = null,
  color = null,
  size = null,
  value = 0,
  ...restProps
}: UIProgressBarProps) {
  return (
    <div
      {...restProps}
      className={classnames('react-progress-bar ', className, {
        [`react-progress-bar--${color}`]: color,
        [`react-progress-bar--${size}`]: size,
      })}
    >
      <div
        className="react-progress-bar__bar"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{
          width: `${value || 0}%`,
        }}
      >
        {children}
      </div>
    </div>
  );
}
